import dayjs from 'dayjs';
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

export default {
	methods: {
        /**
         * Get date Less of max date
         * @param {string} date - such as DD.MM.YYYY
         * @param {string} maxDate - such as DD.MM.YYYY
         * @returns {string} - such as DD.MM.YYYY
         */
        getLessDate(date, maxDate) {
            if (!maxDate) return date;
            const maxDateNormalized = dayjs(maxDate, 'DD.MM.YYYY');
            return dayjs(date, 'DD.MM.YYYY').isBefore(maxDateNormalized, 'day') ? date : maxDateNormalized.subtract(1, 'day').format('DD.MM.YYYY');
        },
        /**
         * Get date Greather Or Equal of min date
         * @param {string} date - such as DD.MM.YYYY
         * @param {string} minDate - such as DD.MM.YYYY
         * @returns {string} - such as DD.MM.YYYY
         */
        getGreatherOrEqualDate(date, minDate) {
            if (!minDate) return date;
            return dayjs(date, 'DD.MM.YYYY').isAfter(dayjs(minDate, 'DD.MM.YYYY'), 'day') ? date : minDate;
        },
		fixFormatDate(date, min, max) {
			if(!date) return;
			var res = this.fixDate(date, this.getValidationDate(max), this.getValidationDate(min)).split('.');
			var day = ('0' + res[0]).slice(-2),
				month = ('0' + res[1]).slice(-2),
				year = res[2];

			return [day, month, year].join('.');
		},
		getDateTime(formattedDate) {
			if (!formattedDate) return;
			var delimiter = formattedDate.indexOf('-') < 0 ? '.' : '-';
			var dateParts = formattedDate.split(delimiter);
			var day = +dateParts[0],
				month = +dateParts[1] - 1,
				year = +dateParts[2];

			if (delimiter === '-') {
				day = +dateParts[2];
				year = +dateParts[0];
			}

			var date = new Date(year, month, day);
			return date.getTime();
		},
		fixDate(formattedDate, min, max) {
			var minDate = min ? this.getDateTime(min) : min;
			var maxDate = max ? this.getDateTime(max) : max;
			var value = this.getDateTime(formattedDate);

			if (value < minDate) {
				return formattedDate.indexOf('-') < 0 ? min : this.formatDateSafari(min);
			}

			if (value > maxDate) {
				return formattedDate.indexOf('-') < 0 ? max : this.formatDateSafari(max);
			}

			return formattedDate;
		},
		getValidationDate(years) {
			if (!years && years !== 0) {
				return undefined;
			}

			var date = new Date();
			date.setFullYear(date.getFullYear() - years);

			return this.formatDate(date);
		},
		formatDateSafari(formattedDate) {
			var dateParts = formattedDate.split('.');

			var day = dateParts[0],
				month = dateParts[1],
				year = dateParts[2];

			return [year, month, day].join('-');
		},
		formatDate(date) {
			var day = +date.getDate(),
				month = +date.getMonth() + 1,
				year = +date.getFullYear();

			return [day, month, year].join('.');
		},
		convertDate(date) {
			if (!date) return '';
			return date.split('.').reverse().join('-');
		},
        convertDateToEng(val) {
            if (!val) return '';
            return val.replace(/\./g, '-').split('-').reverse().join('-');
        },
        correctDate(date) {
            if (!date) return '';
            date = this.convertDateToEng(date);
            date = dayjs(date);

            if( this.disabledDates(date) ) {
                date = '';
                return date;
            }

            date = this.formatDate(date.toDate());
            return date;
        },
	}
}
